import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { GridFilters, initialStateList } from './GridFiltersReducer';
import RollingReserveType from '../types/RollingReserveType';

const initialState = {
  rollingReserveData: { ...initialStateList },
};

export const RollingReseve = handleActions(
  {
    ...GridFilters,
    [RollingReserveType.actions.fetchRollingReserveFiltersSuccess]: (state, { payload: { rollingReserveData } }) => {
      return {
        ...state,
        rollingReserveData,
      };
    },
    [RollingReserveType.actions.fetchRollingReserveDetailsSuccess]: (state, { payload: { rollingReserveDetails } }) => {
      return {
        ...state,
        rollingReserveDetails,
      };
    },
    [RollingReserveType.actions.fetchRollingReserveNextReleaseSuccess]: (state, { payload: { rollingReserveRelease } }) => {
      return {
        ...state,
        rollingReserveRelease,
      };
    },
  },
  initialState
);

const getRollingReserve = (state) => state.RollingReseve;

export const getRollingReserveList = (state, list) => {
  const rollingReserve = getRollingReserve(state);
  return rollingReserve[list] || undefined;
};

export const getRollingReserveData = createSelector(getRollingReserve, (state) => state.rollingReserveData);

export const getRollingReserveCountries = createSelector(getRollingReserve, (state) => state.rollingReserveData.data.map((data) => data.country));
export const getRollingReserveDetails = createSelector(getRollingReserve, (state) => state.rollingReserveDetails);
export const getRollingReserveNextRelesases = createSelector(getRollingReserve, (state) => state.rollingReserveRelease);
